<script lang="ts">
  import { fly } from 'svelte/transition';
  import { createEventDispatcher } from 'svelte';
  import { clickOutside } from '../../../../utils/clickOutside.js';
  import CheckMark from '../../../../CheckMark.svelte';
  import Selectbox from '../../../../Selectbox.svelte';

  const dispatch = createEventDispatcher();

  export let previewMode = false;
  export let sharePanel = false;
  export let usersPanel = false;
  export let uploadToFluentCase = false;
  export let uploadedToFluentCase = false;
  export let matterId = '';
  export let sendPDFType = '';
  export let twilioEnabled = false;
  export let sendingSign = false;
  export let sendPDFRes = false;
  export let selectedChatUser: any = '';
  export let fluentCaseEnabled = false;
  export let clipboardTxt = '';
  export let users: any = [];
  export let chatUsers: any[] = [];
  export let emailSubject = '';
  export let emailCC = '';
  export let friends: any[] = [];
  export let merusToken = '';
  export let merusCaseEnabled = false;
  export let fluentCaseToken = '';
  export let checkIfEmail = false;
  export let user: any = {};
  export let newUserPanel = false;
  export let display_name_panel = false;
  export let sendingNewUser = false;
  export let sendingNewUserType = 0;
  export let emailPanel = false;
  export let smsLang = '';
  export let languages: { value: string; label: string }[] = [];
  export let userName = '';
  export let userPhone = '';
  export let newUserName = '';

  function onShareOutside() {
    dispatch('closeShare');
  }

  function onUsersOutside() {
    dispatch('closeUsers');
  }
</script>

{#if usersPanel && !previewMode}
  <style>
    .selectContainer > div {
      max-width: 460px;
      height: 60vh;
      overflow: auto;
    }
    .selectContainer .listContainer {
      background: #fff;
    }
    .selectContainer .clearSelect {
      height: auto;
    }
  </style>
  <div
    transition:fly={{ y: -200, duration: 500 }}
    class="share-flow-panel w-full fixed z-10 justify-center top-0"
    data-testid="share-flow-panel"
    style="margin-top: 50px;"
    use:clickOutside
    on:click_outside={onUsersOutside}
  >
    <div
      class="share-flow-panel__card border-b border-gray-300 bg-white shadow-lg p-5"
      style="max-width: 700px;margin: auto;position: relative;min-height: 180px;"
    >
      {#if uploadToFluentCase}
        {#if uploadedToFluentCase}
          <p class="text-gray-700 text-center text-lg font-semibold">Uploaded</p>
        {:else}
          <div class="flex items-center justify-between">
            <input
              type="text"
              placeholder="Enter Matter ID"
              class="border p-2 rounded"
              bind:value={matterId}
            />
            <button
              on:click={() => dispatch('uploadFluentCase')}
              class="bg-blue-500 text-white p-2 rounded"
            >
              Upload to FluentCase
            </button>
          </div>
        {/if}
      {:else if sendPDFType == 'sms' && !twilioEnabled}
        <div class="flex items-center" style="justify-content: space-between;">
          <span>You do not have SMS enabled</span>
        </div>
      {:else if sendingSign}
        <div class="flex items-center" style="justify-content: space-between;">
          <span class:hidden={sendPDFType != 'link'}>Generating Link</span>
          <img alt="" src="/loading.gif" style="max-width: 30px;" />
        </div>
      {:else if sendPDFRes}
        {#if sendPDFType != 'link'}
          <div class="w-full half-w-md mx-auto p-2 bg-white rounded-lg">
            <div class="flex items-center gap-2 mb-4">
              <span class="text-lg font-semibold text-gray-700">Sent Successfully</span>
              <CheckMark />
            </div>
            <p class="text-gray-500 text-sm mb-6 leading-relaxed">
              To: {selectedChatUser.fullName} +{selectedChatUser.phone}<br />
              {selectedChatUser.email}
            </p>
            <div class="share-flow-panel__actions flex gap-4">
              <a
                href="https://legalpal.app/chat?chatId={selectedChatUser.id}"
                target="_blank"
                class="flex-2 flex items-center justify-center gap-2 px-6 py-2 border-2 border-blue-400 text-blue-500 rounded-2xl hover:bg-blue-50 transition-colors font-medium text-sm"
              >
                <img alt="conversation icon" src="/img/chatAsset.svg" class="w-5 h-5" />
                Jump to Conversation
              </a>
              {#if fluentCaseEnabled && selectedChatUser.fluentCaseMattersIds && selectedChatUser.fluentCaseMattersIds.length > 0}
                <a
                  href="https://app.fluentcase.com/matters/{selectedChatUser.fluentCaseMattersIds[0]}"
                  target="_blank"
                  class="flex-2 flex items-center justify-center gap-2 px-6 py-2 border-2 border-pink-300 text-pink-500 rounded-2xl hover:bg-pink-50 transition-colors font-medium text-sm"
                >
                  <img alt="case file icon" src="/fluentcase.svg" class="w-5 h-5" />
                  Open Case File
                </a>
              {/if}
            </div>
          </div>
        {:else}
          <div id="clipboard" class="flex flex-col items-center space-y-2">
            <div
              class="flex items-center space-x-2 font-semibold text-lg"
              style="font-family: 'Quicksand', sans-serif;"
            >
              <img src="/chat_icon.svg" alt="Chat Icon" class="w-5 h-5" style="color: currentColor;" />
              <span style="font-family: 'Quicksand', sans-serif;">Your link is ready!</span>
            </div>
            <div
              on:click={() => dispatch('copy')}
              class="flex items-center border border-blue-400 rounded-md px-5 py-3 max-w-full text-xl hover:bg-blue-100"
              style="font-family: 'Quicksand', sans-serif;"
            >
              <a
                target="_blank"
                rel="noopener noreferrer"
                class="text-blue-600 truncate"
                style="font-family: 'Quicksand', sans-serif;"
              >
                {clipboardTxt}
              </a>
              <img
                src="/copy_icon.svg"
                alt="Copy"
                class="w-5 h-5 cursor-pointer ml-3"
                style="color: currentColor;"
                on:click={() => dispatch('copy')}
              />
            </div>
          </div>
        {/if}
      {:else if !newUserPanel}
        {#if !display_name_panel}
          <label
            class="flex items-center h-full hover:bg-gray-500 cursor-pointer mb-4"
            class:hidden={sendPDFType != 'link'}
            style="padding: 5px 10px;"
            on:click={() => dispatch('checkAllObjects')}
          >
            Link you don’t need to select a contact to sign document
          </label>
          {#if users.length > 0 && sendPDFType != 'email'}
            <Selectbox
              bind:emailSubject
              bind:emailCC
              bind:friends
              items={chatUsers}
              type={sendPDFType}
              placeholder="Select a user"
              {merusToken}
              bind:merusCaseEnabled
              bind:fluentCaseEnabled
              bind:fluentCaseToken
              bind:selectedChatUser
              bind:checkIfEmailExternal={checkIfEmail}
              appId={user.appId}
              {user}
              on:select={(e) => dispatch('chatUserSelect', e.detail)}
              on:send={(e) => dispatch('sendSms', e.detail)}
              on:itemAdded={(e) => dispatch('itemAdded', e.detail)}
              on:itemUpdated={(e) => dispatch('itemUpdated', e.detail)}
            />
          {/if}
        {/if}
        {#if sendingNewUser}
          <img
            alt=""
            src="/loading.gif"
            style="max-width: 30px;"
            class:hidden={sendingNewUserType > 0}
          />
          <div
            class="flex items-center"
            class:hidden={sendingNewUserType < 1}
            style="justify-content: space-between;"
          >
            <span>User Added Successfully</span>
            <button
              class="w-30 text-white font-bold py-1 px-3 md:px-4 mr-3 md:mr-4 rounded bg-blue-500 hover:bg-blue-700"
              on:click={() => dispatch('continueSend')}
            >
              Continue
            </button>
            <CheckMark />
          </div>
        {:else}
          <div class="flex share-flow-email-chrome" style="justify-content: space-between;align-items: flex-start;">
            <div class:hidden={sendPDFType != 'email'} class="share-flow-email-body" style="flex: 1; min-width: 0;">
              <div class="flex share-flow-email-row" style="justify-content: space-between;margin-top: 15px; align-items: flex-start; gap: 8px;">
                <button
                  class="w-30 text-white font-bold py-1 px-3 md:px-4 mr-3 md:mr-4 rounded bg-blue-500 hover:bg-blue-700"
                  on:click={() => dispatch('showEmail', { open: true })}
                  class:hidden={emailPanel}
                  data-testid="enter-email-button"
                >
                  Enter Email
                </button>
                {#if emailPanel}
                  <Selectbox
                    bind:emailSubject
                    bind:emailCC
                    bind:friends
                    items={chatUsers}
                    type="email"
                    placeholder="Enter Email"
                    {merusToken}
                    bind:merusCaseEnabled
                    bind:fluentCaseEnabled
                    bind:fluentCaseToken
                    bind:selectedChatUser
                    bind:checkIfEmailExternal={checkIfEmail}
                    appId={user.appId}
                    {user}
                    on:select={(e) => dispatch('chatUserSelect', e.detail)}
                    on:enterEmail={(e) => dispatch('chatUserEnterEmail', e.detail)}
                    on:send={(e) => dispatch('sendEmail', e.detail)}
                    on:itemAdded={(e) => dispatch('itemAdded', e.detail)}
                    on:itemUpdated={(e) => dispatch('itemUpdated', e.detail)}
                  />
                {/if}
                <button
                  type="button"
                  on:click={() => dispatch('showEmail', { open: false })}
                  class="share-flow-email-close cursor-pointer"
                  class:hidden={!emailPanel}
                  aria-label="Close email panel"
                  data-testid="close-email-panel"
                >
                  ×
                </button>
              </div>
            </div>
            <div
              class="share-flow-lang {sendPDFType}"
              style="margin-top: 15px;"
              class:hidden={sendPDFType != 'sms'}
              data-testid="share-flow-lang"
            >
              <select bind:value={smsLang} on:change={() => dispatch('languageSelect')}>
                {#each languages as lang}
                  <option value={lang.value}>{lang.label}</option>
                {/each}
              </select>
            </div>
          </div>
        {/if}
      {:else}
        <span
          on:click={() => dispatch('hideNewUser')}
          class="cursor-pointer"
          class:hidden={!newUserPanel}
          style="float: right;font-size: 1.5rem;margin-top: -1rem;"
        >
          ×
        </span>
        <input
          placeholder="First Name, Last Name"
          type="text"
          class="flex-grow bg-transparent py-1 px-2 w-full"
          class:hidden={display_name_panel}
          style="border: 1px solid;border-radius: 5px;"
          bind:value={userName}
        />
        <input
          placeholder="Phone Number"
          type="text"
          class="flex-grow bg-transparent py-1 px-2 w-full"
          class:hidden={display_name_panel}
          style="border: 1px solid;border-radius: 5px;margin-top: 10px;"
          maxlength="14"
          on:keyup={() => dispatch('checkUserPhone')}
          bind:value={userPhone}
        />
        <button
          class="w-30 text-white font-bold py-1 px-3 md:px-4 mr-3 md:mr-4 rounded bg-blue-500 hover:bg-blue-700"
          style="margin-top: 15px;"
          on:click={() => dispatch('addNewUser')}
          class:hidden={display_name_panel}
        >
          Add User
        </button>
        <input
          placeholder="Insert the name of the Signer"
          type="text"
          class="flex-grow bg-transparent py-1 px-2 w-full"
          style="border: 1px solid;border-radius: 5px;margin-top: 10px;"
          class:hidden={!display_name_panel}
          bind:value={newUserName}
        />
        <button
          class="w-30 text-white font-bold py-1 px-3 md:px-4 mr-3 md:mr-4 rounded bg-blue-500 hover:bg-blue-700"
          style="margin-top: 15px;"
          class:hidden={!display_name_panel}
          on:click={() => dispatch('sendSignature')}
        >
          Next
        </button>
      {/if}
    </div>
  </div>
{/if}

{#if sharePanel && !previewMode}
  <style>
    .shareContainer > div {
      max-width: 460px;
      height: 60vh;
      overflow: auto;
    }
    .sshareContainer .listContainer {
      background: #fff;
    }
  </style>
  <div
    transition:fly={{ y: -200, duration: 500 }}
    class="share-flow-menu w-full fixed z-10 justify-center top-0"
    data-testid="share-flow-menu"
    style="margin-top: 50px;"
    use:clickOutside
    on:click_outside={onShareOutside}
  >
    <div
      class="share-flow-menu__card border-b border-gray-300 bg-white shadow-lg p-5"
      style="max-width: 160px; margin: auto;"
    >
      <label
        class="flex items-center h-full hover:bg-gray-500 cursor-pointer"
        on:click={() => dispatch('sendPdf', { type: 'link' })}
      >
        <img alt="" src="link.svg" style="width: 30px; margin-right: 15px;" />
        <span>Link</span>
      </label>
      <label
        class="flex items-center h-full hover:bg-gray-500 cursor-pointer"
        on:click={() => dispatch('sendPdf', { type: 'sms' })}
      >
        <img alt="" src="sms.svg" style="width: 30px; margin-right: 15px;" />
        <span>SMS</span>
      </label>
      <label
        class="flex items-center h-full hover:bg-gray-500 cursor-pointer"
        on:click={() => dispatch('download')}
      >
        <img alt="" src="download.svg" style="width: 30px; margin-right: 15px;" />
        <span>Download</span>
      </label>
      <label
        class="flex items-center h-full hover:bg-gray-500 cursor-pointer"
        on:click={() => dispatch('sendPdf', { type: 'email' })}
      >
        <img alt="" src="mail.svg" style="width: 30px; margin-right: 15px;" />
        <span>Email</span>
      </label>
    </div>
  </div>
{/if}

<style>
  @media (max-width: 767px) {
    .share-flow-panel {
      margin-top: 3.5rem !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
      padding: 0 12px !important;
      left: 0 !important;
      right: 0 !important;
      width: 100vw !important;
      max-width: 100vw !important;
      box-sizing: border-box !important;
      display: flex !important;
      justify-content: center !important;
    }

    .share-flow-panel__card {
      max-width: 100% !important;
      width: 100% !important;
      margin: 0 !important;
      max-height: calc(100vh - 5rem);
      overflow-y: auto;
      border-radius: 12px;
      box-sizing: border-box;
    }

    .share-flow-panel__actions {
      flex-direction: column;
      gap: 0.75rem !important;
    }

    .share-flow-menu {
      margin-top: 3.5rem !important;
      padding: 0 10px;
    }

    .share-flow-menu__card {
      max-width: min(220px, 90vw) !important;
      width: 100%;
    }

    .share-flow-email-close {
      flex: 0 0 36px;
      width: 36px;
      height: 36px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 1.5rem;
      line-height: 1;
      border: none;
      background: transparent;
      padding: 0;
    }

    :global(.selectContainer > div) {
      max-width: 100% !important;
      height: auto !important;
      max-height: 70vh !important;
    }
  }
</style>
